/**
 * Run `apply` with every CSS transition switched off, so what it changes lands at once.
 *
 * About fifty rules give their own element a colour transition, and the Break Scheduler's
 * timeslot cells alone are some 3,000 of them. A theme switch with the tables open set every one
 * of those running at its own speed: the page changed colour in patches, and starting them all
 * cost the switch a visible hitch. The View Transitions cross-fade on top could not hide it,
 * because the transitions ran inside the "new" picture it was fading to.
 *
 * Reading offsetHeight makes the browser work out the new styles while transitions are still
 * off. Removing the class afterwards starts nothing, since no value changes then.
 */
export default function withoutTransitions(apply) {
  const root = document.documentElement;
  root.classList.add('no-transitions');
  try {
    apply();
    // eslint-disable-next-line no-unused-expressions
    document.body.offsetHeight;
  } finally {
    root.classList.remove('no-transitions');
  }
}
